import React, { useEffect, useContext, useState, useRef } from "react";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import { CircularProgress } from "@material-ui/core";
import { setUserData } from "../Common/Utility/Utils";
import Button from "@material-ui/core/Button";
import $ from "jquery";
import "./login.css";
import { StoreContext } from "../../Store/Provider";
import { baseURL, HOST_URL, ProjectName } from "../../Config";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Sidebar from "./Home/Sidebar/Sidebar";
import axios from "axios";
import Header from "./Home/Header/Header";
import { routeConstant } from "../../Route/utils/routeConstant";
import { localStoragekey } from "../Common/Utility/Utils";
import { useNavigate } from "react-router-dom";
import { path } from "../../order_managment/constants/apiPath";
import { StoreContext as OmsStore } from "../../order_managment/store";
import instance from "../../order_managment/common/api/interceptor";
import { NotificationManager } from "react-notifications";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Login(props) {
  const context = useContext(StoreContext);
  const classes = useStyles();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const inputRef = useRef();
  const history = useNavigate();
  const omscontext = useContext(OmsStore);

  const getUsersAccess = (roles) => {
    instance
      .post(`${path.USER_ACCESS}?roles=${roles}`)
      .then(async (res) => {
        if (res.Is_Success) {
          await omscontext.setUserAccess(res.data ?? {});
          setLoading(false);
          // history(routeConstant.ORDER_DASHBOARD);
        }
      })
      .catch((error) => {
        setLoading(false);
        history(routeConstant.LOGIN);
      });
  };

  const getUserDataInfo = (token) => {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    axios
      .post(`${baseURL}${path.USER_DETAILS}`, null, { headers })
      .then((res) => {
        if (res.data.Is_Success) {
          context.setOmsUserData(res.data.data ?? {});
          getUsersAccess(res.data.data.DefaultRole);

          setLoading(false);
          // history(routeConstant.ORDER_DASHBOARD);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        history(routeConstant.LOGIN);
        if (err.response) {
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
      });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  useEffect(() => {
    context.isUserLogin && history(routeConstant.BlogSFL);
  }, [context.isUserLogin]);

  const showPassword = () => {
    let x = document.getElementById("Password");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
    $(".passIcon").toggleClass("hide");
  };

  const onLogin = () => {
    const emailAddress = username.trim();
    if (!emailAddress) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill User Id!");
    } else if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        emailAddress
      )
    ) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill valid User Id!");
    } else if (!password) {
      setOpenalert(true);
      setSeverity("error");
      setAlertText("Please fill password!");
    } else {
      setLoading(true);
      const params = new URLSearchParams();
      params.append("password", password);
      params.append("username", username);
      params.append("grant_type", "password");
      const end_point = `${HOST_URL}api/OAuth/Token`;

      axios
        .post(end_point, params)
        .then((res) => {
          console.log({ res });
          if (res.data?.WebAccess === "true") {
            res.data.userSecret = password;
            setUserData(res.data, localStoragekey)
              .then(() => {
                context.setIsUserLogin(true);
                getUserDataInfo(res.data.access_token);
                history(routeConstant.BlogSFL);
              })
              .catch(() => {
                context.setIsUserLogin(false);
                history("/");
                setOpenalert(true);
                setSeverity("error");
                setAlertText("Sorry! Unable to Login!");
              });
          } else {
            setOpenalert(true);
            setSeverity("error");
            setAlertText(
              "Your web-access is disabled! Please contact to Admin."
            );
          }
          setLoading(false);
        })
        .catch((error) => {
          context.setIsUserLogin(false);
          console.log({ error });
          setLoading(false);
          if (error.response) {
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            setOpenalert(true);
            setSeverity("error");
            error?.response?.status === 400
              ? setAlertText(error?.response?.data?.error_description)
              : setAlertText(error.response?.data?.Message);
          } else {
            console.log(error);
            setOpenalert(true);
            setSeverity("error");
            setAlertText("Something went wrong!");
          }
        });
    }
  };

  return (
    <div className="home">
      <Header />
      <div className="shipmentsListingHome">
        <Drawer
          variant="persistent"
          className={clsx(classes.drawerLeft, {
            [classes.drawerOpen]: context.menuBar,
            [classes.drawerClose]: !context.menuBar,
          })}
          classes={{
            paper: clsx(classes.drawerPaperleft, {
              [classes.drawerOpen]: context.menuBar,
              [classes.drawerClose]: !context.menuBar,
            }),
          }}
        >
          <Sidebar />
        </Drawer>
        <main className={clsx(classes.content)}>
          <div className="loginScreen">
            <div
              className="loginScreenImage"
              style={{
                backgroundImage: `url(/${ProjectName}/Assets/Images/loginBg.svg)`,
                backgroundSize: "cover",
              }}
            >
              <img
                src={`/${ProjectName}/Assets/Images/LogoTransparent.png`}
                alt="LogoTransparent"
              />
            </div>
            <div className="loginScreenForm">
              <div className="loginForm">
                <div className="loginFormHeading">
                  <span>Welcome,</span>
                  <p>
                    We are glad that you are here, <br />
                    Let’s get started!
                  </p>
                </div>
                <div>
                  <input
                    type="text"
                    className="form-control"
                    value={username}
                    ref={inputRef}
                    placeholder="Enter your e-mail address"
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div className="loginPasswordDiv">
                  <input
                    type="password"
                    id="Password"
                    value={password}
                    className="form-control"
                    placeholder="Enter your password"
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        onLogin();
                      }
                    }}
                  />
                  <span className="showpassword pointer" onClick={showPassword}>
                    <VisibilityOffOutlinedIcon className="passIcon" />
                    <VisibilityOutlinedIcon className="passIcon hide" />
                  </span>
                </div>
                <div className="forgotPass">
                  <span
                    onClick={() => {
                      history(routeConstant.ForgotPassword);
                    }}
                  >
                    Forgot Password
                  </span>
                </div>
                <div className="loginFormSubmit">
                  <Button
                    variant="contained"
                    className="form-control"
                    onClick={onLogin}
                  >
                    {loading ? <CircularProgress size="2rem" /> : "Login"}
                  </Button>{" "}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerLeft: {
    width: "18%",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 3rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "18%",
    minWidth: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
  },
}));

export default Login;
